import { FormasPagamento, StatusContrato, StatusPagamentosPagos, StatusPedido } from '../plugins/constants'
import { StatusBoletoCarrinho } from '../plugins/multiplasCotasBoletoStatus'

export function permiteRetentarGeracaoProposta (id_documento, status_pedido) {
  return !id_documento && ![StatusPedido.AGENDADO_GERAR_PROPOSTA_CARRINHO, StatusPedido.GERANDO_PROPOSTA_CARRINHO].includes(status_pedido)
}
export function permiteReenviarContrato (contrato) {
  return contrato && contrato.status && contrato.status === StatusContrato.ContratoPendente
}

export function permiteReenviarBoleto (status_boleto, forma_pagamento) {
  return status_boleto === StatusBoletoCarrinho.AguardandoPagamento && forma_pagamento === FormasPagamento.Boleto
}

export function permiteReenviarPagamento (status_boleto, forma_pagamento, status_pedido) {
  return !StatusPagamentosPagos.includes(status_pedido) && ((status_boleto === StatusBoletoCarrinho.AguardandoPagamento && forma_pagamento === FormasPagamento.Boleto) || forma_pagamento === FormasPagamento.Link)
}

export function permiteAlterarFormaPagamento (status_pedido, id_documento, job_carrinho_boleto_agendado, status_boleto) {
  const statusPagamentoValido = [StatusBoletoCarrinho.AguardandoPagamento, StatusBoletoCarrinho.AguardandoFormaPagamento].includes(status_boleto)

  return (
    statusPagamentoValido &&
    !StatusPagamentosPagos.includes(status_pedido) &&
    id_documento &&
    job_carrinho_boleto_agendado !== true
  )
}
